// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/font-awesome/css/font-awesome.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("img/select.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clearfix:before,
.clearfix:after {
  display: table;
  content: " ";
}
.clearfix:after {
  clear: both;
}
.pull-right {
  float: right !important;
}
.pull-left {
  float: left !important;
}
.hide {
  display: none !important;
}
.show {
  display: block !important;
}
.invisible {
  visibility: hidden;
}
.hidden {
  display: none !important;
}
.affix {
  position: fixed;
}
@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }
}
@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
}
@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
}
@-moz-keyframes slideFadeRight {
  0% {
    transform: translate(-20px, 0);
    opacity: 0;
  }
}
@-webkit-keyframes slideFadeRight {
  0% {
    transform: translate(-20px, 0);
    opacity: 0;
  }
}
@-o-keyframes slideFadeRight {
  0% {
    transform: translate(-20px, 0);
    opacity: 0;
  }
}
@keyframes slideFadeRight {
  0% {
    transform: translate(-20px, 0);
    opacity: 0;
  }
}
@-moz-keyframes slideFadeLeft {
  0% {
    transform: translate(20px, 0);
    opacity: 0;
  }
}
@-webkit-keyframes slideFadeLeft {
  0% {
    transform: translate(20px, 0);
    opacity: 0;
  }
}
@-o-keyframes slideFadeLeft {
  0% {
    transform: translate(20px, 0);
    opacity: 0;
  }
}
@keyframes slideFadeLeft {
  0% {
    transform: translate(20px, 0);
    opacity: 0;
  }
}
@-moz-keyframes slideFadeUp {
  0% {
    transform: translate(0, 10px);
    opacity: 0;
  }
}
@-webkit-keyframes slideFadeUp {
  0% {
    transform: translate(0, 10px);
    opacity: 0;
  }
}
@-o-keyframes slideFadeUp {
  0% {
    transform: translate(0, 10px);
    opacity: 0;
  }
}
@keyframes slideFadeUp {
  0% {
    transform: translate(0, 10px);
    opacity: 0;
  }
}
@-moz-keyframes pliegoBorderVertical {
  0% {
    height: 0%;
  }
}
@-webkit-keyframes pliegoBorderVertical {
  0% {
    height: 0%;
  }
}
@-o-keyframes pliegoBorderVertical {
  0% {
    height: 0%;
  }
}
@keyframes pliegoBorderVertical {
  0% {
    height: 0%;
  }
}
@-moz-keyframes pliegoBorderHorizontal {
  0% {
    width: 0%;
  }
}
@-webkit-keyframes pliegoBorderHorizontal {
  0% {
    width: 0%;
  }
}
@-o-keyframes pliegoBorderHorizontal {
  0% {
    width: 0%;
  }
}
@keyframes pliegoBorderHorizontal {
  0% {
    width: 0%;
  }
}
* {
  box-sizing: border-box;
}
body {
  margin: 0;
  padding: 0;
  background-color: #f0efea;
  padding: 20px;
}
@media (min-width: 768px) {
  body {
    padding: 20px 30px;
  }
}
@media (min-width: 1024px) {
  body {
    padding: 20px 40px;
  }
}
body,
button,
input,
textarea,
select {
  font-family: 'Manrope', Arial, sans-serif;
  font-size: 16px;
  line-height: 1.2;
}
a {
  color: #000;
  text-decoration: none;
  transition: 0.2s ease;
  display: inline-block;
  border-bottom: 2px solid transparent;
}
a:hover {
  border-color: #000;
}
p {
  margin: 0 0 20px;
  padding: 0;
}
ol {
  padding-left: 16px;
}
h1,
.h1 {
  padding: 0;
  margin: 0 0 20px;
  font-size: 2em;
}
@media (min-width: 480px) {
  h1,
  .h1 {
    font-size: 2em;
  }
}
@media (min-width: 768px) {
  h1,
  .h1 {
    font-size: 3em;
  }
}
@media (min-width: 1024px) {
  h1,
  .h1 {
    font-size: 4em;
    line-height: 1.1;
  }
}
h2,
.h2 {
  padding: 0;
  margin: 0 0 20px;
  font-size: 1.5em;
}
@media (min-width: 480px) {
  h2,
  .h2 {
    font-size: 2em;
  }
}
@media (min-width: 768px) {
  h2,
  .h2 {
    font-size: 3em;
  }
}
@media (min-width: 1024px) {
  h2,
  .h2 {
    font-size: 3.5em;
  }
}
h3,
.h3 {
  padding: 0;
  margin: 0 0 20px;
  font-size: 1.2em;
}
@media (min-width: 480px) {
  h3,
  .h3 {
    font-size: 1.25em;
  }
}
@media (min-width: 768px) {
  h3,
  .h3 {
    font-size: 1.5em;
  }
}
h4,
.h4 {
  padding: 0;
  margin: 0 0 20px;
  font-size: 1em;
}
@media (min-width: 480px) {
  h4,
  .h4 {
    font-size: 1.1em;
  }
}
@media (min-width: 768px) {
  h4,
  .h4 {
    font-size: 1.2em;
  }
}
ul {
  padding-left: 20px;
}
ul li {
  margin-bottom: 5px;
}
ul li:last-child {
  margin-bottom: 0px;
}
img {
  width: 100%;
  height: auto;
  display: block;
  margin: 0;
  padding: 0;
}
hr {
  border-top: 2px solid #000;
  margin: 30px 0;
}
video {
  display: block;
  width: 100%;
}
audio {
  display: inline-block;
  vertical-align: middle;
}
button {
  user-select: none;
}
.fa {
  display: inline-block;
  vertical-align: middle;
}
.h--400,
.text--400 {
  font-weight: 400;
}
.text--center {
  text-align: center;
}
.grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;
}
.grid.grid--gap {
  gap: 30px;
}
@media (min-width: 768px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1024px) {
  .grid.grid--3 {
    grid-template-columns: repeat(3, 1fr);
  }
  .grid.grid--catalog {
    grid-template-columns: repeat(3, minmax(300px, 1fr));
  }
  .grid.grid--contact {
    grid-template-columns: 0.6fr 1.4fr;
  }
}
.grid.grid--contact {
  gap: 30px;
}
.grid.grid--contact input,
.grid.grid--contact textarea,
.grid.grid--contact button {
  max-width: none;
  width: 100%;
}
.grid.grid--contact label {
  display: block;
  width: 100%;
}
.flex {
  display: flex;
  flex-wrap: wrap;
  margin: -15px;
}
.flex.flex--auto {
  flex-wrap: nowrap;
}
.flex>div {
  display: block;
  box-sizing: border-box;
  padding: 15px;
  width: 100%;
}
@media (min-width: 768px) {
  .flex .flex__20 {
    width: 20%;
  }
  .flex .flex__25 {
    width: 25%;
  }
  .flex .flex__30 {
    width: 30%;
  }
  .flex .flex__33 {
    width: 33.33%;
  }
  .flex .flex__35 {
    width: 35%;
  }
  .flex .flex__40 {
    width: 40%;
  }
  .flex .flex__45 {
    width: 45%;
  }
  .flex .flex__50 {
    width: 50%;
  }
  .flex .flex__55 {
    width: 55%;
  }
  .flex .flex__60 {
    width: 60%;
  }
  .flex .flex__65 {
    width: 65%;
  }
  .flex .flex__66 {
    width: 66.66%;
  }
  .flex .flex__70 {
    width: 70%;
  }
  .flex .flex__75 {
    width: 75%;
  }
  .flex .flex__80 {
    width: 80%;
  }
}
.pliego {
  position: relative;
}
@media (min-width: 480px) {
  .pliego {
    padding-bottom: 150%;
  }
}
@media (min-width: 768px) {
  .pliego {
    padding-bottom: 56.25%;
    padding-bottom: 54%;
    padding: 0;
    height: calc(100vh - 180px);
    min-height: 640px;
  }
}
@media (min-width: 480px) {
  .pliego .pliego__cuts {
    border: 2px solid #000;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
@media (min-width: 480px) {
  .pliego .pliego__cut {
    position: relative;
    width: 100%;
    height: 50%;
  }
}
@media (min-width: 768px) {
  .pliego .pliego__cut {
    width: 50%;
    height: 100%;
    float: left;
  }
}
.pliego .pliego__a {
  border: 2px solid #000;
  margin-bottom: -2px;
  background-size: cover;
  background-position: center center;
  overflow: hidden;
}
@media (min-width: 480px) {
  .pliego .pliego__a {
    position: relative;
    float: left;
    border: 0;
    margin: 0;
  }
  .pliego .pliego__a.pliego__a3::after,
  .pliego .pliego__a.pliego__a5::after,
  .pliego .pliego__a.pliego__a7::after,
  .pliego .pliego__a.pliego__a9::after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    width: 2px;
    height: 100%;
    background: #000;
    animation: pliegoBorderVertical 1s ease backwards;
  }
  .pliego .pliego__a.pliego__a1::after,
  .pliego .pliego__a.pliego__a2::after,
  .pliego .pliego__a.pliego__a4::after,
  .pliego .pliego__a.pliego__a6::after,
  .pliego .pliego__a.pliego__a8::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background: #000;
    animation: pliegoBorderHorizontal 1s ease backwards;
  }
  .pliego .pliego__a.pliego__a1::after {
    animation-delay: 0.2s;
  }
  .pliego .pliego__a.pliego__a2::after {
    animation-delay: 0.3s;
  }
  .pliego .pliego__a.pliego__a3::after {
    animation-delay: 0.4s;
  }
  .pliego .pliego__a.pliego__a4::after {
    animation-delay: 0.5s;
  }
  .pliego .pliego__a.pliego__a5::after {
    animation-delay: 0.6s;
  }
  .pliego .pliego__a.pliego__a6::after {
    animation-delay: 0.7s;
  }
  .pliego .pliego__a.pliego__a7::after {
    animation-delay: 0.8s;
  }
  .pliego .pliego__a.pliego__a8::after {
    animation-delay: 0.9s;
  }
  .pliego .pliego__a.pliego__a9::after {
    animation-delay: 1s;
  }
  .pliego .pliego__a1 {
    width: 100%;
    height: 100%;
  }
  .pliego .pliego__a1 .pliego__link {
    position: absolute;
    bottom: 30px;
    left: 30px;
  }
  .pliego .pliego__a2 {
    width: 100%;
    height: 50%;
  }
  .pliego .pliego__a3 {
    height: 50%;
    width: 50%;
  }
  .pliego .pliego__a4 {
    height: 25%;
    width: 50%;
  }
  .pliego .pliego__a5 {
    width: 25%;
    height: 25%;
  }
  .pliego .pliego__a6 {
    width: 25%;
    height: 12.5%;
  }
  .pliego .pliego__a7 {
    width: 12.5%;
    height: 12.5%;
  }
  .pliego .pliego__a8 {
    width: 12.5%;
    height: 6.25%;
  }
}
@media (min-width: 768px) {
  .pliego .pliego__a.pliego__a1::after {
    right: 0;
    top: 0;
    left: auto;
    bottom: auto;
    width: 2px;
    height: 100%;
    animation-name: pliegoBorderVertical;
  }
}
.map__ui .map__category {
  margin: 0;
  margin-bottom: 10px;
}
.map__ui .map__category:last-child {
  margin: 0;
}
.map__ui .map__category .map__category_title {
  font-size: 1.1em;
  font-size: 1em;
  padding: 15px 0;
  margin: 0;
  cursor: pointer;
  border: 2px solid #000;
  padding: 15px 20px;
  transition: 0.2s ease;
}
.map__ui .map__category .map__category_title span {
  font-size: 1.2em;
  float: right;
  margin-left: 5px;
}
.map__ui .map__category._opened .map__category_title {
  background: rgba(70,230,102,0.4);
}
.map__ui .map__category._opened .map__accordeon {
  display: block;
}
.map__ui .map__accordeon {
  overflow: hidden;
  animation: fadeIn 0.5s ease;
  display: none;
  margin: 20px 0;
}
.map__ui .map__list {
  list-style-type: none;
  padding: 0;
  margin: 0 0 1px;
}
.map__ui .map__list li {
  margin-bottom: -1px;
}
.map__ui .map__list li a {
  display: block;
  padding: 10px 30px 10px 0;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
}
.map__ui .map__list li a:hover {
  padding-left: 15px;
  padding-right: 15px;
}
.map__ui .map__list li a.active {
  background: rgba(70,230,102,0.4);
  padding-left: 15px;
  padding-right: 15px;
}
.map__formats {
  padding: 30px;
  animation: fadeIn 0.5s ease;
}
.map__formats ul {
  list-style-type: none;
  padding: 0;
}
.map__formats ul strong {
  display: block;
  margin-bottom: -20px;
}
.map__formats ul li {
  padding: 10px 0;
  border-top: 1px solid rgba(0,0,0,0.2);
  animation: slideFadeUp 0.5s ease backwards;
}
.map__formats ul li:nth-child(1) {
  animation-delay: 0.1s;
}
.map__formats ul li:nth-child(2) {
  animation-delay: 0.15s;
}
.map__formats ul li:nth-child(3) {
  animation-delay: 0.2s;
}
.map__formats ul li:nth-child(4) {
  animation-delay: 0.25s;
}
.map__formats ul li:nth-child(5) {
  animation-delay: 0.3s;
}
.map__formats ul li li {
  border: 0;
  padding: 0;
  text-align: right;
  animation: none;
}
.imprenta-papeles {
  border-top: 2px solid #000;
  padding-top: 15px;
  margin-top: 5px;
}
.gm-style-iw {
  border-radius: 0 !important;
  border: 2px solid #000;
}
.gm-style-iw .gm-style-iw-chr {
  position: relative;
  z-index: 2;
}
.gm-style-iw .gm-style-iw-d {
  margin-top: -20px;
}
.gm-style-iw .gm-style-iw-d .map__infowindow {
  min-width: 220px;
  padding: 10px;
  padding: 0 30px 0 10px;
  position: relative;
  z-index: 2;
  font-family: 'Manrope', Arial, sans-serif;
}
.gm-style-iw .gm-style-iw-d .map__infowindow h3 {
  margin: 0 0 10px;
  font-size: 1.4em;
}
.gm-style-iw .gm-style-iw-d .map__infowindow p {
  margin-bottom: 10px;
}
.gm-style .gm-style-iw-tc::after {
  background: #000;
}
label {
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}
input,
select,
textarea {
  vertical-align: middle;
  line-height: 20px;
}
input,
textarea {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: 10px 15px;
  border: 2px solid #000;
  display: block;
}
input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 20px;
  height: 20px;
  background-color: transparent;
  border: 2px solid rgba(0,0,0,0.25);
  border-radius: 3px;
  cursor: pointer;
}
input[type="checkbox"]:checked {
  background-color: #000;
  border-color: #000;
}
input[type="checkbox"]:checked::after {
  content: "";
  display: block;
  width: 6px;
  height: 10px;
  border: 2px solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  margin: 0 3px;
}
select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: 10px 15px;
  border: 2px solid #000;
  min-width: 120px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) right center no-repeat;
  background-size: 30px;
}
input[type="range"] {
  -webkit-appearance: none;
  background: rgba(0,0,0,0.2);
  height: 4px;
  border-radius: 20px;
}
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  background: #000;
  border-radius: 50%;
  cursor: pointer;
}
input[type="range"]::-moz-range-thumb {
  width: 20px;
  height: 20px;
  background: #000;
  border-radius: 50%;
  cursor: pointer;
}
input[type="range"]::-ms-thumb {
  width: 20px;
  height: 20px;
  background: #000;
  border-radius: 50%;
  cursor: pointer;
}
.btn {
  display: inline-block;
  user-select: none;
  background: transparent;
  color: #000;
  padding: 10px 20px;
  border: 2px solid #000;
  -webkit-appearance: none;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.85em;
  cursor: pointer;
  border-radius: 0;
  transition: 0.2s ease;
  vertical-align: middle;
  line-height: 20px;
}
@media (min-width: 768px) {
  .btn {
    font-size: 0.95em;
    letter-spacing: 1px;
  }
}
.btn:hover {
  background: #000;
  color: #fff;
}
.btn:hover svg path {
  fill: #fff;
}
.btn svg {
  display: inline-block;
  max-height: 16px;
  max-width: 16px;
  vertical-align: -4px;
  margin: 0 5px 0 0;
}
.btn.btn--black {
  background: #000;
  color: #fff;
}
.btn.btn--block {
  display: block;
  width: 100%;
  margin: 0;
}
.btn.btn--link {
  border: 0;
  border-bottom: 2px solid transparent;
  padding-left: 0;
  padding-right: 0;
}
.btn.btn--link:hover {
  background: transparent;
  color: #000;
  border-color: #000;
}
.btn.btn--md {
  padding: 12px 25px;
}
header {
  margin-bottom: 20px;
  overflow: hidden;
}
@media (min-width: 768px) {
  header {
    margin-top: 5px;
    margin-bottom: 20px;
  }
}
header .header__logo {
  font-weight: bold;
  color: #000;
  text-decoration: none;
  display: inline-block;
  vertical-align: middle;
  margin: 0 20px 0 0;
  float: left;
  border: 0;
}
header .header__logo img {
  width: 60px;
  height: 70px;
  margin: 0;
}
header .header__right {
  margin-left: 80px;
}
@media (min-width: 768px) {
  header .header__right {
    margin-left: 0;
    padding-top: 10px;
    float: right;
  }
}
header .header__search {
  width: 100%;
  position: relative;
  display: none;
}
@media (min-width: 768px) {
  header .header__search {
    width: 200px;
    display: inline-block;
  }
}
@media (min-width: 1440px) {
  header .header__search {
    width: 250px;
  }
}
header .header__search input {
  border-radius: 0;
  padding-right: 40px;
  padding-left: 20px;
  width: 100%;
  background-color: transparent;
}
header .header__search button {
  position: absolute;
  border-radius: 0;
  top: 0;
  right: 0;
}
header .header__bread {
  opacity: 0.4;
}
header .header__nav {
  display: inline-block;
  vertical-align: middle;
  margin-right: 20px;
}
@media (max-width: 768px) {
  header .header__nav {
    float: right;
  }
}
header .header__nav ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
header .header__nav ul li {
  position: relative;
  margin: 0 8px;
  display: inline-block;
}
@media (min-width: 1024px) {
  header .header__nav ul li {
    margin: 0 20px;
  }
}
header .header__nav ul li a {
  font-weight: bold;
  font-size: 16px;
  color: #000;
  text-decoration: none;
  display: block;
  padding: 2px 0;
  border-bottom: 2px solid transparent;
}
@media (min-width: 1024px) {
  header .header__nav ul li a {
    padding: 5px 0;
  }
}
header .header__nav ul li a .fa {
  margin-top: -2px;
}
header .header__nav ul li a:hover {
  border-color: #000;
}
header .header__nav ul li.current-menu-item::before {
  display: block;
  content: "";
  position: absolute;
  top: 50%;
  left: -10%;
  width: 120%;
  height: 40%;
  background: #46e666;
  transform: rotate(-2deg);
  opacity: 0.25;
}
#body {
  display: none;
}
#body.body--loaded {
  display: block !important;
  animation: fadeIn 0.5s ease;
}
footer {
  margin-top: 20px;
  font-size: 0.85em;
}
@media (min-width: 768px) {
  footer {
    font-size: 0.9em;
  }
}
footer a {
  display: block;
  margin: 5px 0;
}
@media (min-width: 768px) {
  footer a {
    display: inline-block;
    margin: 0 6px;
  }
}
footer span {
  display: none;
}
@media (min-width: 768px) {
  footer span {
    display: inline-block;
  }
}
footer .footer__logos .footer__logo {
  margin: 0;
}
footer .footer__logos .footer__logo img {
  width: 160px;
  height: 200px;
  margin: 0;
}
section {
  margin-bottom: 30px;
  animation: fadeIn 0.5s 0.2s ease backwards;
}
section:last-child {
  margin-bottom: 0;
}
section .section__breadcrumb {
  margin-bottom: 5px;
}
section .section__breadcrumb a {
  position: relative;
}
section .section__content {
  line-height: 1.5;
  font-size: 1.2em;
}
section .section__body {
  padding: 30px;
}
section .section__pagination .page-numbers {
  display: inline-block;
  padding: 5px 10px;
}
section .section__pagination span {
  background: #000;
  color: #fff;
  margin: 0 5px;
}
section .section__pagination span:first-child {
  margin-left: 0;
}
section.section--border {
  border: 2px solid #000;
}
section.section--map {
  border: 2px solid #000;
  margin-bottom: 0;
}
section.section--map .section__body {
  padding: 30px;
  max-height: 710px;
  overflow: auto;
}
@media (min-width: 768px) {
  section.section--map .section__body {
    height: calc(100vh - 190px);
    max-height: none;
  }
}
section.section--map #map {
  height: 400px;
}
@media (min-width: 768px) {
  section.section--map #map {
    height: 100%;
  }
}
section.section--map .grid>div:nth-child(2) {
  border-top: 2px solid #000;
}
@media (min-width: 768px) {
  section.section--map .grid>div:nth-child(2) {
    border-top: 0;
    border-left: 2px solid #000;
  }
}
section.section--map .section__title {
  line-height: 0.8;
  margin-bottom: 30px;
}
section .section__alianzas a {
  display: inline-block;
  padding: 10px 20px 10px 0;
  border: 0;
}
section .section__alianzas a img {
  max-height: 70px;
  max-width: 200px;
  display: inline-block;
  vertical-align: middle;
}
section .section__imgbg {
  background: center center no-repeat;
  background-size: cover;
  height: 300px;
}
@media (min-width: 768px) {
  section .section__imgbg {
    height: 600px;
  }
}
article.article--pliego {
  position: relative;
  height: 100%;
  padding: 30px;
  animation: slideFadeLeft 0.8s 0.2s ease backwards;
  transition: 0.25s ease;
}
@media (min-width: 1424px) {
  article.article--pliego {
    padding: 40px;
  }
}
article.article--pliego:hover {
  background: rgba(70,230,102,0.4);
}
article.article--pliego:hover .word::before {
  background-color: #fff;
}
article.article--pliego.article--pliego-about {
  animation-delay: 0.5s;
}
article.article--pliego.article--pliego-imprentas {
  animation-delay: 0.6s;
}
article.article--pliego.article--pliego-metropolitana {
  animation-delay: 0.7s;
}
article.article--pliego.article--pliego-valparaiso {
  animation-delay: 0.8s;
}
article.article--pliego.article--pliego-downloads {
  animation-delay: 0.9s;
}
article.article--pliego.article--pliego-contact {
  animation-delay: 1s;
}
article.article--pliego .article__excerpt {
  line-height: 1.5;
}
@media (min-width: 768px) {
  article.article--pliego h1.article__title {
    font-size: 3vw;
  }
  article.article--pliego h2.article__title {
    font-size: 2vw;
  }
  article.article--pliego h3.article__title {
    font-size: 1.6vw;
    max-width: 60%;
  }
}
article.article--pliego .article__link {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
article.article--pliego .article__link svg {
  width: 30px;
  height: 30px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
}
article.article--pliego .article__link span {
  position: absolute;
  bottom: 30px;
  right: 30px;
  display: inline-block;
  font-size: 1.6vw;
  font-weight: bold;
  line-height: 1.1;
  opacity: 0;
  right: 40px;
  transition: 0.5s ease;
}
article.article--pliego .article__link:hover span {
  opacity: 1;
  right: 30px;
}
article.article--pliego.article--pliego-imprentas .article__formats {
  margin-bottom: 5px;
  overflow: hidden;
}
article.article--pliego.article--pliego-imprentas .article__formats .format-icon {
  animation: slideFadeLeft 0.5s ease backwards;
}
article.article--pliego.article--pliego-imprentas .article__formats .format-icon:nth-child(1) {
  animation-delay: 0.5s;
}
article.article--pliego.article--pliego-imprentas .article__formats .format-icon:nth-child(2) {
  animation-delay: 0.6s;
}
article.article--pliego.article--pliego-imprentas .article__formats .format-icon:nth-child(3) {
  animation-delay: 0.7s;
}
article.article--pliego.article--pliego-imprentas .article__formats .format-icon:nth-child(4) {
  animation-delay: 0.8s;
}
article.article--pliego.article--pliego-imprentas .article__formats .format-icon:nth-child(5) {
  animation-delay: 0.9s;
}
article.article--pliego.article--pliego-region .article__bread,
article.article--pliego.article--pliego-region .article__title {
  position: relative;
}
article.article--pliego.article--pliego-region .article__bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
  opacity: 1;
  transition: 0.5s ease;
}
article.article--pliego.article--pliego-region:hover {
  background: rgba(70,230,102,0.6);
}
article.article--pliego.article--pliego-region:hover .article__bg {
  opacity: 0.25;
}
article.article--pliego.article--pliego-small {
  padding: 30px;
}
article.article--pliego.article--pliego-small .article__link span.texttt {
  display: block;
  width: 200px;
  bottom: 50%;
  right: 50%;
  margin-right: -100px;
  margin-bottom: -16px;
  text-align: center;
  opacity: 1;
  font-size: 20px;
}
article.article--pliego.article--pliego-downloads .article__link span.textttXXXX {
  transform: rotate(-90deg);
}
article.article--file a {
  display: block;
  padding: 15px 0;
  border-top: 2px solid #000;
  border-bottom: 0;
}
article.article--file a .article__title {
  display: block;
  font-size: 1.5em;
  font-weight: normal;
}
article.article--file a .article__description {
  display: block;
  opacity: 0.6;
  margin-bottom: 5px;
}
article.article--file a .article__download {
  font-weight: bold;
  text-transform: uppercase;
  display: inline-block;
  transition: 0.2s ease;
  padding: 5px 10px;
  background: #000;
  color: #fff;
}
@media (min-width: 768px) {
  article.article--file a .article__download {
    margin-top: -30px;
    float: right;
  }
}
article.article--file a:hover {
  background: #000;
  padding: 15px 20px;
  color: #fff;
}
article.article--region-imprentas {
  border: 2px solid #000;
  margin-bottom: -2px;
}
article.article--region-imprentas .article__title {
  margin: 0;
}
article.article--region-imprentas a {
  display: block;
  padding: 20px;
}
article.article--region-imprentas a:hover {
  background: #000;
  color: #fff;
}
article.article--region-imprentas a span {
  font-weight: normal;
  font-size: 0.7em;
  opacity: 0.5;
  display: inline-block;
  margin-left: 5px;
}
article.article--result {
  border: 2px solid #000;
  padding: 20px;
}
article.article--team .article__image {
  position: relative;
  background: #eee;
  border: 2px solid #000;
  margin-bottom: 10px;
}
article.article--team .article__title {
  font-size: 1em;
  margin-bottom: 5px;
}
.section__swiper {
  margin: 0 -30px;
}
@media (min-width: 768px) {
  .section__swiper {
    margin: 0;
  }
}
.swiper.swiper--main {
  position: relative;
  user-select: none;
  overflow: hidden;
}
.swiper-thumbnails {
  display: flex;
  gap: 5px;
  margin: 5px 0 0;
}
.swiper-thumbnails .swiper-thumbnail {
  cursor: pointer;
  opacity: 0.6;
  transition: 0.2s ease;
  position: relative;
}
.swiper-thumbnails .swiper-thumbnail.--current {
  opacity: 1;
  z-index: 2;
}
.swiper-thumbnails .swiper-thumbnail.--current::after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 2px solid #000;
  box-sizing: border-box;
}
.swiper-thumbnails .swiper-thumbnail:hover {
  opacity: 1;
}
.swiper-thumbnails.swiper-thumbnails--B {
  display: flex;
  gap: 0;
  margin: 0;
  flex-wrap: wrap;
}
.swiper-thumbnails.swiper-thumbnails--B .swiper-thumbnail {
  width: 33.33%;
  box-sizing: border-box;
}
.swiper-button-next,
.swiper-button-prev {
  color: #000 !important;
  opacity: 0.2;
  transition: 0.2s ease;
}
.swiper-button-next:hover,
.swiper-button-prev:hover {
  opacity: 1;
}
.swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #000;
}
.word {
  position: relative;
  display: inline-block;
}
.word::before {
  display: none;
  content: "";
  position: absolute;
  top: 50%;
  left: -5%;
  width: 110%;
  height: 50%;
  transform: rotate(-2deg);
  opacity: 0.25;
  transition: 0.5s ease;
}
.word.word--optimizar::before,
.word.word--formatos::before,
.word.word--eficiente::before {
  display: block;
  background: #46e666;
}
.format-header {
  float: right;
  text-align: right;
  margin: -40px 0 10px;
  word-spacing: 3px;
  font-size: 14px;
/*span
        display inline-block
        vertical-align middle
        font-size 14px
        &.format__p
            width 60px
            //text-align right
            margin-right 10px
        &.format__w
            width 45px
            text-align right
        &.format__h
            width 45px
            padding-left 10px
            text-align left
    */
}
.format {
  line-height: 1;
}
.format span {
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
}
.format span.format__p {
  width: 60px;
  text-align: right;
  margin-right: 10px;
}
.format span.format__w {
  font-size: 1em;
  width: 45px;
  text-align: right;
}
.format span.format__h {
  font-size: 1em;
  width: 45px;
  text-align: left;
  padding-left: 15px;
}
.format span.format__cm {
  padding-left: 2px;
}
.format:hover {
  background: rgba(70,230,102,0.3);
}
.format-icon {
  width: 16px;
  height: 20px;
  display: block;
  float: left;
  border: 1px solid rgba(0,0,0,0.8);
  margin-right: 10px;
  margin-bottom: 10px;
  position: relative;
}
.format-icon span {
  display: block;
  position: relative;
  background: rgba(70,230,102,0.5);
  border: 1px dashed rgba(0,0,0,0.6);
  margin-top: -1px;
  margin-left: -1px;
}
.format-icon.format-icon-mini span {
  height: 20%;
  width: 20%;
}
.format-icon.format-icon-pequeno span {
  height: 35%;
  width: 35%;
}
.format-icon.format-icon-mediano span {
  height: 50%;
  width: 50%;
}
.format-icon.format-icon-grande span {
  height: 65%;
  width: 65%;
}
.format-icon.format-icon-max span,
.format-icon.format-icon-maxi span {
  height: 80%;
  width: 80%;
}
.format-icon.format-icon-md {
  width: 32px;
  height: 40px;
}
.format-icon.format-icon-lg {
  width: 64px;
  height: 80px;
}
.format-icon.format-icon-lg span {
  border-width: 1px;
}
.unit {
  border: 1px solid #000;
  border-radius: 8px;
  display: block;
  float: right;
  margin-left: 10px;
  padding: 2px;
}
.unit .unit-option {
  display: inline-block;
  padding: 4px 6px;
  cursor: pointer;
  border-radius: 5px;
  transition: 0.2s ease;
  font-size: 14px;
}
.unit .unit-option.active {
  background: rgba(70,230,102,0.5);
}
`, "",{"version":3,"sources":["webpack://./node_modules/bootstrap-styl/bootstrap/mixins/clearfix.styl","webpack://./src/styles/main.styl","webpack://./node_modules/bootstrap-styl/bootstrap/utilities.styl","webpack://./src/styles/components/animations.styl","webpack://./src/styles/components/global.styl","webpack://./src/styles/components/grid.styl","webpack://./src/styles/components/pliego.styl","webpack://./src/styles/components/maps.styl","webpack://./src/styles/components/forms.styl","webpack://./src/styles/components/buttons.styl","webpack://./src/styles/components/header.styl","webpack://./src/styles/components/body.styl","webpack://./src/styles/components/footer.styl","webpack://./src/styles/components/sections.styl","webpack://./src/styles/components/articles.styl","webpack://./src/styles/components/swiper.styl","webpack://./src/styles/components/word.styl","webpack://./src/styles/components/formats.styl"],"names":[],"mappings":"AAYE;;EAEE,cAAQ;EACR,YAAQ;ACXZ;ADaE;EACE,WAAM;ACXV;ACSA;EACE,uBAAM;ADPR;ACSA;EACE,sBAAM;ADPR;ACcA;EACE,wBAAQ;ADZV;ACcA;EACE,yBAAQ;ADZV;ACcA;EACE,kBAAW;ADZb;ACsBA;EACE,wBAAQ;ADpBV;AC0BA;EACE,eAAS;ADxBX;AEpBA;EACI;IACI,UAAQ;EFuBd;AACF;AE1BA;EACI;IACI,UAAQ;EF4Bd;AACF;AE/BA;EACI;IACI,UAAQ;EFiCd;AACF;AEpCA;EACI;IACI,UAAQ;EFsCd;AACF;AEpCA;EACI;IACI,8BAAU;IACV,UAAQ;EFsCd;AACF;AE1CA;EACI;IACI,8BAAU;IACV,UAAQ;EF4Cd;AACF;AEhDA;EACI;IACI,8BAAU;IACV,UAAQ;EFkDd;AACF;AEtDA;EACI;IACI,8BAAU;IACV,UAAQ;EFwDd;AACF;AEtDA;EACI;IACI,6BAAU;IACV,UAAQ;EFwDd;AACF;AE5DA;EACI;IACI,6BAAU;IACV,UAAQ;EF8Dd;AACF;AElEA;EACI;IACI,6BAAU;IACV,UAAQ;EFoEd;AACF;AExEA;EACI;IACI,6BAAU;IACV,UAAQ;EF0Ed;AACF;AEzEA;EACI;IACI,6BAAU;IACV,UAAQ;EF2Ed;AACF;AE/EA;EACI;IACI,6BAAU;IACV,UAAQ;EFiFd;AACF;AErFA;EACI;IACI,6BAAU;IACV,UAAQ;EFuFd;AACF;AE3FA;EACI;IACI,6BAAU;IACV,UAAQ;EF6Fd;AACF;AE3FA;EACI;IACI,UAAO;EF6Fb;AACF;AEhGA;EACI;IACI,UAAO;EFkGb;AACF;AErGA;EACI;IACI,UAAO;EFuGb;AACF;AE1GA;EACI;IACI,UAAO;EF4Gb;AACF;AE3GA;EACI;IACI,SAAM;EF6GZ;AACF;AEhHA;EACI;IACI,SAAM;EFkHZ;AACF;AErHA;EACI;IACI,SAAM;EFuHZ;AACF;AE1HA;EACI;IACI,SAAM;EF4HZ;AACF;AG5JA;EACI,sBAAW;AH8Jf;AG5JA;EACI,SAAO;EACP,UAAQ;EACR,yBAAiB;EACjB,aAAQ;AH8JZ;AG7J8B;EAAA;IACtB,kBAAQ;EHgKd;AACF;AGhK+B;EAAA;IACvB,kBAAQ;EHmKd;AACF;AGlKA;;;;;EACI,yCAAqB;EACrB,eAAU;EACV,gBAAY;AHwKhB;AGtKA;EACI,WAAM;EACN,qBAAgB;EAChB,qBAAW;EACX,qBAAQ;EACR,oCAAc;AHwKlB;AGvKI;EACI,kBAAa;AHyKrB;AGvKA;EACI,gBAAO;EACP,UAAQ;AHyKZ;AGvKA;EACI,kBAAa;AHyKjB;AGvKA;;EACI,UAAQ;EACR,gBAAO;EACP,cAAU;AH0Kd;AGzK8B;EAAA;;IACtB,cAAU;EH6KhB;AACF;AG7K8B;EAAA;;IACtB,cAAU;EHiLhB;AACF;AGhL+B;EAAA;;IACvB,cAAU;IACV,gBAAY;EHoLlB;AACF;AGnLA;;EACI,UAAQ;EACR,gBAAO;EACP,gBAAU;AHsLd;AGrL8B;EAAA;;IACtB,cAAU;EHyLhB;AACF;AGzL8B;EAAA;;IACtB,cAAU;EH6LhB;AACF;AG7L+B;EAAA;;IACvB,gBAAU;EHiMhB;AACF;AGhMA;;EACI,UAAQ;EACR,gBAAO;EACP,gBAAU;AHmMd;AGlM8B;EAAA;;IACtB,iBAAU;EHsMhB;AACF;AGtM8B;EAAA;;IACtB,gBAAU;EH0MhB;AACF;AGzMA;;EACI,UAAQ;EACR,gBAAO;EACP,cAAU;AH4Md;AG3M8B;EAAA;;IACtB,gBAAU;EH+MhB;AACF;AG/M8B;EAAA;;IACtB,gBAAU;EHmNhB;AACF;AGjNA;EACI,kBAAa;AHmNjB;AGlNI;EACI,kBAAc;AHoNtB;AGnNQ;EACI,kBAAc;AHqN1B;AGpNA;EACI,WAAM;EACN,YAAO;EACP,cAAQ;EACR,SAAO;EACP,UAAQ;AHsNZ;AGpNA;EACI,0BAAW;EACX,cAAO;AHsNX;AGpNA;EACI,cAAQ;EACR,WAAM;AHsNV;AGpNA;EACI,qBAAQ;EACR,sBAAe;AHsNnB;AGpNA;EACI,iBAAY;AHsNhB;AGpNA;EACI,qBAAQ;EACR,sBAAe;AHsNnB;AGjNA;;EAEI,gBAAY;AHmNhB;AGjNA;EACI,kBAAW;AHmNf;AIxUA;EACI,aAAQ;EACR,0BAAsB;EACtB,MAAI;AJ0UR;AIxUI;EACI,SAAI;AJ0UZ;AIxU8B;EAAA;IACtB,qCAAsB;EJ2U5B;AACF;AI1U+B;EACvB;IACI,qCAAuB;EJ4UjC;EI1UM;IACI,oDAAuB;EJ4UjC;EI1UM;IACI,kCAAuB;EJ4UjC;AACF;AI3UI;EACI,SAAI;AJ6UZ;AI5UQ;;;EAGI,eAAU;EACV,WAAM;AJ8UlB;AI7UQ;EACI,cAAQ;EACR,WAAM;AJ+UlB;AI5UA;EACI,aAAQ;EACR,eAAU;EACV,aAAO;AJ8UX;AI7UI;EACI,iBAAU;AJ+UlB;AI7UI;EACI,cAAQ;EACR,sBAAW;EACX,aAAQ;EACR,WAAM;AJ+Ud;AI5U8B;EACtB;IACI,UAAM;EJ8UhB;EI5UM;IACI,UAAM;EJ8UhB;EI5UM;IACI,UAAM;EJ8UhB;EI5UM;IACI,aAAM;EJ8UhB;EI5UM;IACI,UAAM;EJ8UhB;EI5UM;IACI,UAAM;EJ8UhB;EI5UM;IACI,UAAM;EJ8UhB;EI5UM;IACI,UAAM;EJ8UhB;EI5UM;IACI,UAAM;EJ8UhB;EI5UM;IACI,UAAM;EJ8UhB;EI5UM;IACI,UAAM;EJ8UhB;EI5UM;IACI,aAAM;EJ8UhB;EI5UM;IACI,UAAM;EJ8UhB;EI5UM;IACI,UAAM;EJ8UhB;EI5UM;IACI,UAAM;EJ8UhB;AACF;AK3aA;EACI,kBAAS;AL6ab;AK5a8B;EAAA;IACtB,oBAAe;EL+arB;AACF;AK/a8B;EAAA;IACtB,sBAAe;IACf,mBAAe;IACf,UAAQ;IACR,2BAAO;IACP,iBAAW;ELkbjB;AACF;AKhbkC;EAAA;IACtB,sBAAO;IACP,kBAAS;IACT,MAAI;IACJ,OAAK;IACL,WAAM;IACN,YAAO;ELmbjB;AACF;AKjbkC;EAAA;IACtB,kBAAS;IACT,WAAM;IACN,WAAO;ELobjB;AACF;AKpbkC;EAAA;IACtB,UAAM;IACN,YAAO;IACP,WAAM;ELubhB;AACF;AKtbI;EACI,sBAAO;EACP,mBAAc;EACd,sBAAgB;EAChB,kCAAoB;EACpB,gBAAS;ALwbjB;AKtb8B;EAGtB;IACI,kBAAS;IACT,WAAM;IACN,SAAO;IACP,SAAO;ELsbjB;EK/ac;;;;IACI,WAAQ;IACR,kBAAS;IACT,QAAM;IACN,MAAI;IACJ,UAAM;IACN,YAAO;IACP,gBAAW;IACX,iDAAU;ELob5B;EK5ac;;;;;IACI,WAAQ;IACR,kBAAS;IACT,OAAK;IACL,SAAO;IACP,WAAM;IACN,WAAO;IACP,gBAAW;IACX,mDAAU;ELkb5B;EKhbU;IACI,qBAAgB;ELkb9B;EKjbU;IACI,qBAAgB;ELmb9B;EKlbU;IACI,qBAAgB;ELob9B;EKnbU;IACI,qBAAgB;ELqb9B;EKpbU;IACI,qBAAgB;ELsb9B;EKrbU;IACI,qBAAgB;ELub9B;EKtbU;IACI,qBAAgB;ELwb9B;EKvbU;IACI,qBAAgB;ELyb9B;EKxbU;IACI,mBAAgB;EL0b9B;EKtbM;IACI,WAAM;IACN,YAAO;ELwbjB;EKvbU;IACI,kBAAS;IACT,YAAO;IACP,UAAK;ELybnB;EKvbM;IACI,WAAM;IACN,WAAO;ELybjB;EKvbM;IACI,WAAO;IACP,UAAM;ELybhB;EKvbM;IACI,WAAO;IACP,UAAM;ELybhB;EKvbM;IACI,UAAM;IACN,WAAO;ELybjB;EKvbM;IACI,UAAM;IACN,aAAO;ELybjB;EKvbM;IACI,YAAM;IACN,aAAO;ELybjB;EKvbM;IACI,YAAM;IACN,aAAO;ELybjB;AACF;AKvb8B;EAMd;IACI,QAAM;IACN,MAAI;IACJ,UAAK;IACL,YAAO;IACP,UAAM;IACN,YAAO;IACP,oCAAe;ELobjC;AACF;AMxkBI;EAEI,SAAO;EACP,mBAAc;ANykBtB;AMxkBQ;EACI,SAAO;AN0kBnB;AMzkBQ;EACI,gBAAU;EAEV,cAAU;EACV,eAAQ;EACR,SAAO;EACP,eAAO;EACP,sBAAO;EACP,kBAAQ;EACR,qBAAW;AN0kBvB;AMzkBY;EACI,gBAAU;EACV,YAAM;EACN,gBAAY;AN2kB5B;AMzkBY;EACI,gCAAW;AN2kB3B;AM1kBY;EACI,cAAQ;AN4kBxB;AM1kBI;EACI,gBAAS;EACT,2BAAU;EACV,aAAQ;EACR,cAAO;AN4kBf;AM1kBI;EACI,qBAAgB;EAChB,UAAQ;EACR,eAAO;AN4kBf;AM3kBQ;EACI,mBAAc;AN6kB1B;AM5kBY;EACI,cAAQ;EACR,yBAAQ;EACR,0BAAW;EACX,6BAAc;AN8kB9B;AM7kBgB;EACI,kBAAa;EACb,mBAAc;AN+kBlC;AM9kBgB;EACI,gCAAW;EACX,kBAAa;EACb,mBAAc;ANglBlC;AM5kBA;EACI,aAAQ;EACR,2BAAU;AN8kBd;AM7kBI;EACI,qBAAgB;EAChB,UAAQ;AN+kBhB;AM9kBQ;EACI,cAAQ;EACR,oBAAc;ANglB1B;AM/kBQ;EACI,eAAQ;EACR,qCAAW;EACX,0CAAU;ANilBtB;AMhlBY;EACI,qBAAgB;ANklBhC;AMjlBY;EACI,sBAAgB;ANmlBhC;AMllBY;EACI,qBAAgB;ANolBhC;AMnlBY;EACI,sBAAgB;ANqlBhC;AMplBY;EACI,qBAAgB;ANslBhC;AMrlBY;EACI,SAAO;EACP,UAAQ;EACR,iBAAW;EACX,eAAU;ANulB1B;AMrlBA;EACI,0BAAW;EACX,iBAAY;EACZ,eAAW;ANulBf;AMjlBA;EACI,2BAAc;EACd,sBAAO;ANmlBX;AMjlBI;EACI,kBAAS;EACT,UAAQ;ANmlBhB;AMjlBI;EACI,iBAAW;ANmlBnB;AMjlBQ;EACI,gBAAU;EACV,aAAQ;EACR,sBAAQ;EACR,kBAAS;EACT,UAAQ;EACR,yCAAqB;ANmlBjC;AMllBY;EACI,gBAAO;EACP,gBAAU;ANolB1B;AMnlBY;EACI,mBAAc;ANqlB9B;AMnlBA;EACI,gBAAW;ANqlBf;AO7sBA;EACE,qBAAQ;EACR,sBAAe;EACf,eAAO;AP+sBT;AO7sBA;;;EACI,sBAAe;EACf,iBAAY;APitBhB;AO/sBA;;EACI,gBAAW;EACX,wBAAmB;EACnB,qBAAgB;EAChB,kBAAQ;EACR,sBAAO;EACP,cAAQ;APktBZ;AO/sBA;EACI,gBAAW;EACX,wBAAmB;EACnB,qBAAgB;EAChB,WAAM;EACN,YAAO;EACP,6BAAiB;EACjB,kCAAQ;EACR,kBAAc;EACd,eAAO;APitBX;AO/sBA;EACI,sBAAiB;EACjB,kBAAa;APitBjB;AO/sBA;EACI,WAAQ;EACR,cAAQ;EACR,UAAM;EACN,YAAO;EACP,sBAAO;EACP,yBAAa;EACb,wBAAU;EACV,aAAO;APitBX;AO9sBA;EACI,gBAAW;EACX,wBAAmB;EACnB,qBAAgB;EAChB,kBAAQ;EACR,sBAAO;EACP,gBAAU;EACV,0EAAgC;EAChC,qBAAgB;APgtBpB;AO3sBA;EACE,wBAAoB;EACpB,2BAAW;EACX,WAAO;EACP,mBAAc;AP6sBhB;AOzsBA;EACE,wBAAoB;EACpB,gBAAY;EACZ,WAAO;EACP,YAAQ;EACR,gBAAW;EACX,kBAAe;EACf,eAAQ;AP2sBV;AOxsBA;EACE,WAAO;EACP,YAAQ;EACR,gBAAW;EACX,kBAAe;EACf,eAAQ;AP0sBV;AOvsBA;EACE,WAAO;EACP,YAAQ;EACR,gBAAW;EACX,kBAAe;EACf,eAAQ;APysBV;AQjyBA;EACI,qBAAQ;EACR,iBAAY;EACZ,uBAAW;EACX,WAAM;EACN,kBAAQ;EACR,sBAAO;EACP,wBAAmB;EACnB,yBAAe;EACf,iBAAY;EACZ,iBAAU;EAIV,eAAO;EACP,gBAAc;EACd,qBAAW;EACX,sBAAe;EACf,iBAAY;ARgyBhB;AQvyB8B;EAAA;IACtB,iBAAU;IACV,mBAAe;ER0yBrB;AACF;AQryBI;EACI,gBAAW;EACX,WAAM;ARuyBd;AQryBY;EACI,UAAK;ARuyBrB;AQtyBI;EACI,qBAAQ;EACR,gBAAW;EACX,eAAU;EACV,oBAAe;EACf,iBAAO;ARwyBf;AQtyBI;EACI,gBAAW;EACX,WAAM;ARwyBd;AQtyBI;EACI,cAAQ;EACR,WAAM;EACN,SAAO;ARwyBf;AQtyBI;EACI,SAAO;EACP,oCAAc;EACd,eAAa;EACb,gBAAc;ARwyBtB;AQvyBQ;EACI,uBAAW;EACX,WAAM;EACN,kBAAa;ARyyBzB;AQtyBI;EACI,kBAAQ;ARwyBhB;AS71BA;EACI,mBAAc;EAEd,gBAAS;AT81Bb;AS71B8B;EAAA;IACtB,eAAW;IACX,mBAAc;ETg2BpB;AACF;AS/1BI;EACI,iBAAY;EACZ,WAAM;EACN,qBAAgB;EAChB,qBAAQ;EACR,sBAAe;EACf,kBAAO;EACP,WAAM;EACN,SAAO;ATi2Bf;ASh2BQ;EACI,WAAM;EACN,YAAO;EACP,SAAO;ATk2BnB;AS/1BI;EAEI,iBAAa;ATg2BrB;AS/1BkC;EAAA;IACtB,cAAY;IACZ,iBAAY;IACZ,YAAM;ETk2BhB;AACF;ASh2BI;EACI,WAAM;EACN,kBAAS;EACT,aAAQ;ATk2BhB;ASj2BkC;EAAA;IACtB,YAAM;IACN,qBAAQ;ETo2BlB;AACF;ASp2BsC;EAAA;IAC1B,YAAM;ETu2BhB;AACF;ASt2BQ;EACI,gBAAc;EACd,mBAAc;EACd,kBAAa;EACb,WAAM;EACN,6BAAiB;ATw2B7B;ASv2BQ;EACI,kBAAS;EACT,gBAAc;EACd,MAAI;EACJ,QAAM;ATy2BlB;ASt2BI;EACI,YAAQ;ATw2BhB;ASt2BI;EACI,qBAAQ;EACR,sBAAe;EACf,kBAAa;ATw2BrB;ASv2BkC;EAAA;IACtB,YAAM;ET02BhB;AACF;AS12BQ;EACI,qBAAgB;EAChB,UAAQ;EACR,SAAO;AT42BnB;AS32BY;EACI,kBAAS;EACT,aAAO;EACP,qBAAQ;AT62BxB;AS52B2C;EAAA;IACvB,cAAO;ET+2BzB;AACF;AS/2BgB;EACI,iBAAY;EACZ,eAAU;EACV,WAAM;EACN,qBAAgB;EAChB,cAAQ;EACR,cAAQ;EACR,oCAAc;ATi3BlC;ASh3B+C;EAAA;IACvB,cAAQ;ETm3B9B;AACF;ASn3BoB;EACI,gBAAW;ATq3BnC;ASp3BoB;EACI,kBAAa;ATs3BrC;ASn3BoB;EACI,cAAQ;EACR,WAAQ;EACR,kBAAS;EACT,QAAI;EACJ,UAAK;EACL,WAAM;EACN,WAAO;EACP,mBAAW;EACX,wBAAU;EACV,aAAQ;ATq3BhC;AUx9BA;EACI,aAAQ;AV09BZ;AUx9BI;EACI,yBAAQ;EACR,2BAAU;AV09BlB;AWh+BA;EACI,gBAAW;EACX,iBAAU;AXk+Bd;AWj+B6B;EAAA;IACrB,gBAAU;EXo+BhB;AACF;AWp+BI;EACI,cAAQ;EACR,aAAO;AXs+Bf;AWr+BiC;EAAA;IACrB,qBAAQ;IACR,aAAO;EXw+BjB;AACF;AWx+BI;EACI,aAAQ;AX0+BhB;AWz+BiC;EAAA;IACrB,qBAAQ;EX4+BlB;AACF;AW1+BQ;EACI,SAAO;AX4+BnB;AW3+BY;EACI,YAAM;EACN,aAAO;EACP,SAAO;AX6+BvB;AY7/BA;EACI,mBAAc;EACd,0CAAU;AZ+/Bd;AY9/BI;EACI,gBAAc;AZggCtB;AY9/BI;EACI,kBAAc;AZggCtB;AY//BQ;EACI,kBAAS;AZigCrB;AY//BI;EACI,gBAAY;EACZ,gBAAU;AZigClB;AY//BI;EACI,aAAQ;AZigChB;AY9/BQ;EACI,qBAAQ;EACR,iBAAQ;AZggCpB;AY//BQ;EACI,gBAAW;EACX,WAAM;EACN,aAAO;AZigCnB;AYhgCY;EACI,cAAY;AZkgC5B;AY//BI;EACI,sBAAO;AZigCf;AY7/BI;EACI,sBAAO;EACP,gBAAc;AZ+/BtB;AY7/BQ;EACI,aAAQ;EACR,iBAAW;EACX,cAAS;AZ+/BrB;AY9/BsC;EAAA;IACtB,2BAAO;IACP,gBAAW;EZigCzB;AACF;AYhgCQ;EAEI,aAAO;AZigCnB;AYhgCsC;EAAA;IACtB,YAAO;EZmgCrB;AACF;AYlgCQ;EACI,0BAAW;AZogCvB;AYngCsC;EAAA;IACtB,aAAW;IACX,2BAAY;EZsgC1B;AACF;AYrgCQ;EACI,gBAAY;EACZ,mBAAc;AZugC1B;AYlgCQ;EACI,qBAAQ;EACR,yBAAQ;EACR,SAAO;AZogCnB;AYngCY;EACI,gBAAW;EACX,gBAAU;EACV,qBAAQ;EACR,sBAAe;AZqgC/B;AYjgCI;EACI,mCAAW;EACX,sBAAgB;EAChB,aAAO;AZmgCf;AYlgCkC;EAAA;IACtB,aAAO;EZqgCjB;AACF;AazlCA;EACI,kBAAS;EACT,YAAO;EACP,aAAQ;EACR,iDAAU;EACV,sBAAW;Ab2lCf;Aa1lCmC;EAAA;IAC3B,aAAQ;Eb6lCd;AACF;Aa5lCI;EACI,gCAAW;Ab8lCnB;Aa5lCY;EACI,sBAAiB;Ab8lCjC;Aa5lCI;EACI,qBAAgB;Ab8lCxB;Aa5lCI;EACI,qBAAgB;Ab8lCxB;Aa5lCI;EACI,qBAAgB;Ab8lCxB;Aa5lCI;EACI,qBAAgB;Ab8lCxB;Aa5lCI;EACI,qBAAgB;Ab8lCxB;Aa5lCI;EACI,mBAAgB;Ab8lCxB;Aa1lCI;EACI,gBAAY;Ab4lCpB;Aa1lC8B;EACtB;IACI,cAAU;Eb4lCpB;Ea3lCM;IACI,cAAU;Eb6lCpB;Ea5lCM;IACI,gBAAU;IACV,cAAU;Eb8lCpB;AACF;Aa7lCI;EACI,cAAQ;EACR,kBAAS;EACT,MAAI;EACJ,OAAK;EACL,WAAM;EACN,YAAO;EACP,SAAO;Ab+lCf;Aa9lCQ;EACI,WAAM;EACN,YAAO;EACP,qBAAQ;EACR,sBAAe;EACf,iBAAY;AbgmCxB;Aa/lCQ;EACI,kBAAS;EACT,YAAO;EACP,WAAM;EACN,qBAAQ;EACR,gBAAU;EACV,iBAAY;EACZ,gBAAY;EACZ,UAAQ;EACR,WAAM;EACN,qBAAW;AbimCvB;Aa/lCY;EACI,UAAQ;EACR,WAAM;AbimCtB;Aa7lCQ;EACI,kBAAc;EACd,gBAAS;Ab+lCrB;Aa9lCY;EACI,4CAAU;AbgmC1B;Aa/lCgB;EACI,qBAAgB;AbimCpC;AahmCgB;EACI,qBAAgB;AbkmCpC;AajmCgB;EACI,qBAAgB;AbmmCpC;AalmCgB;EACI,qBAAgB;AbomCpC;AanmCgB;EACI,qBAAgB;AbqmCpC;AalmCQ;;EAEI,kBAAS;AbomCrB;AanmCQ;EACI,kBAAS;EACT,MAAI;EACJ,OAAK;EACL,WAAM;EACN,YAAO;EACP,sBAAgB;EAChB,kCAAoB;EACpB,UAAQ;EACR,qBAAW;AbqmCvB;AapmCQ;EACI,gCAAW;AbsmCvB;AarmCY;EACI,aAAQ;AbumCxB;AapmCI;EACI,aAAQ;AbsmChB;AapmCY;EACI,cAAQ;EACR,YAAM;EACN,WAAO;EACP,UAAM;EACN,oBAAa;EACb,oBAAc;EACd,kBAAW;EACX,UAAQ;EACR,eAAU;AbsmC1B;AajmCY;EACI,yBAAU;AbmmC1B;Aa7lCI;EACI,cAAQ;EACR,eAAQ;EACR,0BAAW;EACX,gBAAc;Ab+lCtB;Aa9lCQ;EACI,cAAQ;EACR,gBAAU;EACV,mBAAY;AbgmCxB;Aa/lCQ;EACI,cAAQ;EACR,YAAQ;EACR,kBAAc;AbimC1B;AahmCQ;EACI,iBAAY;EACZ,yBAAe;EACf,qBAAQ;EACR,qBAAW;EACX,iBAAQ;EACR,gBAAW;EACX,WAAM;AbkmClB;AajmCsC;EAAA;IACtB,iBAAW;IACX,YAAM;EbomCpB;AACF;AapmCQ;EACI,gBAAW;EACX,kBAAQ;EACR,WAAM;AbsmClB;AalmCA;EACI,sBAAO;EACP,mBAAc;AbomClB;AanmCI;EACI,SAAO;AbqmCf;AapmCI;EACI,cAAQ;EACR,aAAQ;AbsmChB;AarmCQ;EACI,gBAAW;EACX,WAAM;AbumClB;AatmCQ;EACI,mBAAY;EACZ,gBAAU;EACV,YAAQ;EACR,qBAAQ;EACR,gBAAY;AbwmCxB;AatmCA;EACI,sBAAO;EACP,aAAQ;AbwmCZ;AanmCI;EACI,kBAAS;EACT,gBAAW;EACX,sBAAO;EACP,mBAAc;AbqmCtB;AapmCI;EACI,cAAU;EACV,kBAAc;AbsmCtB;AcjzCA;EACI,eAAO;AdmzCX;AclzC8B;EAAA;IACtB,SAAO;EdqzCb;AACF;AcpzCA;EACI,kBAAS;EACT,iBAAY;EACZ,gBAAS;AdszCb;AcpzCA;EACI,aAAQ;EACR,QAAI;EACJ,eAAO;AdszCX;AcpzCI;EACI,eAAO;EACP,YAAQ;EACR,qBAAW;EACX,kBAAS;AdszCjB;AcrzCQ;EACI,UAAQ;EACR,UAAQ;AduzCpB;ActzCY;EACI,WAAQ;EACR,cAAQ;EACR,kBAAS;EACT,MAAI;EACJ,OAAK;EACL,WAAM;EACN,YAAO;EACP,sBAAO;EACP,sBAAW;AdwzC3B;AcvzCQ;EACI,UAAQ;AdyzCpB;AcvzCI;EACI,aAAQ;EAER,MAAI;EAEJ,SAAO;EACP,eAAU;AduzClB;AcrzCQ;EAEI,aAAM;EACN,sBAAW;AdszCvB;AcnzCA;;EACI,sBAAM;EACN,YAAQ;EACR,qBAAW;AdszCf;AcrzCI;;EACI,UAAQ;AdwzChB;AcrzCA;EACI,gBAAW;AduzCf;Aet3CA;EACI,kBAAS;EACT,qBAAQ;Afw3CZ;Aev3CI;EACI,aAAQ;EACR,WAAQ;EACR,kBAAS;EACT,QAAI;EACJ,SAAK;EACL,WAAM;EACN,WAAO;EACP,wBAAU;EACV,aAAQ;EACR,qBAAW;Afy3CnB;Aev3CI;;;EAGI,cAAQ;EACR,mBAAW;Afy3CnB;AgB74CA;EACI,YAAM;EACN,iBAAW;EACX,oBAAO;EACP,iBAAa;EACb,eAAU;AACV;;;;;;;;;;;;;;;KhB65CC;AACL;AgB74CA;EACI,cAAY;AhB+4ChB;AgB94CI;EACI,qBAAQ;EACR,sBAAe;EACf,eAAU;AhBg5ClB;AgB/4CQ;EACI,WAAM;EACN,iBAAW;EACX,kBAAa;AhBi5CzB;AgBh5CQ;EACI,cAAU;EACV,WAAM;EACN,iBAAW;AhBk5CvB;AgBj5CQ;EACI,cAAU;EACV,WAAM;EACN,gBAAW;EACX,kBAAa;AhBm5CzB;AgBl5CQ;EACI,iBAAa;AhBo5CzB;AgBn5CI;EACI,gCAAW;AhBq5CnB;AgBn5CA;EACI,WAAM;EACN,YAAO;EACP,cAAQ;EACR,WAAM;EACN,iCAAO;EACP,kBAAa;EACb,mBAAc;EACd,kBAAS;AhBq5Cb;AgBn5CI;EACI,cAAQ;EACR,kBAAS;EACT,gCAAW;EACX,kCAAO;EACP,gBAAW;EACX,iBAAY;AhBq5CpB;AgBl5CQ;EACI,WAAO;EACP,UAAM;AhBo5ClB;AgBl5CQ;EACI,WAAO;EACP,UAAM;AhBo5ClB;AgBl5CQ;EACI,WAAO;EACP,UAAM;AhBo5ClB;AgBl5CQ;EACI,WAAO;EACP,UAAM;AhBo5ClB;AgBj5CQ;;EACI,WAAO;EACP,UAAM;AhBo5ClB;AgBl5CI;EACI,WAAM;EACN,YAAO;AhBo5Cf;AgBl5CI;EACI,WAAM;EACN,YAAO;AhBo5Cf;AgBn5CQ;EACI,iBAAa;AhBq5CzB;AgBh5CA;EACI,sBAAO;EACP,kBAAc;EACd,cAAQ;EACR,YAAM;EACN,iBAAY;EACZ,YAAQ;AhBk5CZ;AgBj5CI;EACI,qBAAQ;EACR,gBAAQ;EACR,eAAO;EACP,kBAAc;EACd,qBAAW;EACX,eAAU;AhBm5ClB;AgBl5CQ;EACI,gCAAW;AhBo5CvB","sourcesContent":["// Clearfix\n//\n// For modern browsers\n// 1. The space content is one way to avoid an Opera bug when the\n// contenteditable attribute is included anywhere else in the document.\n// Otherwise it causes space to appear at the top and bottom of elements\n// that are clearfixed.\n// 2. The use of `table` rather than `block` is only necessary if using\n// `:before` to contain the top-margins of child elements.\n//\n// Source http://nicolasgallagher.com/micro-clearfix-hack/\nclearfix()\n  &:before,\n  &:after\n    display table // 2\n    content \" \" // 1\n\n  &:after\n    clear both\n","\n// -----------------------------\n// VARS ------------------------\n// -----------------------------\n\n$color = #46e666\n\n$mobile = 480px\n$tablet = 768px\n$desktop = 1024px\n$desktop-lg = 1440px\n\n@import '../../node_modules/bootstrap-styl/bootstrap/variables'\n@import '../../node_modules/bootstrap-styl/bootstrap/mixins/clearfix'\n@import '../../node_modules/bootstrap-styl/bootstrap/mixins/grid-framework'\n@import '../../node_modules/bootstrap-styl/bootstrap/mixins/grid'\n@import '../../node_modules/bootstrap-styl/bootstrap/utilities'\n\n@import '../../node_modules/font-awesome/css/font-awesome.css'\n\n\n@import 'components/animations'\n@import 'components/global'\n@import 'components/grid'\n@import 'components/pliego'\n@import 'components/maps'\n@import 'components/forms'\n@import 'components/buttons'\n@import 'components/header'\n@import 'components/body'\n@import 'components/footer'\n@import 'components/sections'\n@import 'components/articles'\n@import 'components/swiper'\n@import 'components/word'\n@import 'components/formats'\n","// stylelint-disable declaration-no-important\n\n//\n// Utility classes\n// --------------------------------------------------\n\n\n// Floats\n// -------------------------\n\n.clearfix\n  clearfix()\n\n.center-block\n  center-block()\n\n.pull-right\n  float right !important\n\n.pull-left\n  float left !important\n\n\n// Toggling content\n// -------------------------\n\n// Note Deprecated .hide in favor of .hidden or .sr-only (as appropriate) in v3.0.1\n.hide\n  display none !important\n\n.show\n  display block !important\n\n.invisible\n  visibility hidden\n\n.text-hide\n  text-hide()\n\n\n// Hide from screenreaders and browsers\n//\n// Credit HTML5 Boilerplate\n\n.hidden\n  display none !important\n\n\n// For Affix plugin\n// -------------------------\n\n.affix\n  position fixed\n","\n\n\n// -----------------------------\n// Animations ------------------\n// -----------------------------\n\n\n@keyframes fadeIn\n    0%\n        opacity 0\n\n\n@keyframes slideFadeRight\n    0%\n        transform translate(-20px,0)\n        opacity 0\n\n\n@keyframes slideFadeLeft\n    0%\n        transform translate(20px,0)\n        opacity 0\n\n@keyframes slideFadeUp\n    0%\n        transform translate(0,10px)\n        opacity 0\n\n\n@keyframes pliegoBorderVertical\n    0%\n        height 0%\n\n@keyframes pliegoBorderHorizontal\n    0%\n        width 0%\n","\n// -----------------------------\n// Global styles ---------------\n// -----------------------------\n\n*\n    box-sizing border-box\n\nbody\n    margin 0\n    padding 0\n    background-color #f0efea\n    padding 20px\n    @media (min-width: $tablet)\n        padding 20px 30px\n    @media (min-width: $desktop)\n        padding 20px 40px\n\nbody,button,input,textarea,select\n    font-family 'Manrope', Arial, sans-serif\n    font-size 16px\n    line-height 1.2\n\na\n    color black\n    text-decoration none\n    transition .2s ease\n    display inline-block\n    border-bottom 2px solid transparent\n    &:hover\n        border-color black\n\np\n    margin 0 0 20px\n    padding 0\n\nol\n    padding-left 16px\n\nh1, .h1\n    padding 0\n    margin 0 0 20px\n    font-size 2em\n    @media (min-width: $mobile)\n        font-size 2em\n    @media (min-width: $tablet)\n        font-size 3em\n        //letter-spacing -1px\n    @media (min-width: $desktop)\n        font-size 4em\n        line-height 1.1\n        //letter-spacing -2px\nh2, .h2\n    padding 0\n    margin 0 0 20px\n    font-size 1.5em\n    @media (min-width: $mobile)\n        font-size 2em\n    @media (min-width: $tablet)\n        font-size 3em\n    @media (min-width: $desktop)\n        font-size 3.5em\n\nh3, .h3\n    padding 0\n    margin 0 0 20px\n    font-size 1.2em\n    @media (min-width: $mobile)\n        font-size 1.25em\n    @media (min-width: $tablet)\n        font-size 1.5em\n    \nh4, .h4\n    padding 0\n    margin 0 0 20px\n    font-size 1em\n    @media (min-width: $mobile)\n        font-size 1.1em\n    @media (min-width: $tablet)\n        font-size 1.2em\n\n\nul\n    padding-left 20px\n    li\n        margin-bottom 5px\n        &:last-child\n            margin-bottom 0px\nimg\n    width 100%\n    height auto\n    display block\n    margin 0\n    padding 0\n\nhr\n    border-top 2px solid black\n    margin 30px 0\n\nvideo\n    display block\n    width 100%\n\naudio\n    display inline-block\n    vertical-align middle\n\nbutton\n    user-select none\n\n.fa\n    display inline-block\n    vertical-align middle\n\n\n// HELPERS -----------------\n\n.h--400,\n.text--400\n    font-weight 400\n\n.text--center\n    text-align center","// -----------------------------\n// Grid ------------------\n// -----------------------------\n\n\n.grid\n    display grid\n    grid-template-columns 1fr  // Una sola columna en pantallas pequeñas (mobile first)\n    gap 0\n\n    &.grid--gap\n        gap 30px\n\n    @media (min-width: $tablet)\n        grid-template-columns repeat(2, 1fr)\n\n    @media (min-width: $desktop)\n        &.grid--3\n            grid-template-columns: repeat(3, 1fr)   // Tres columnas iguales\n\n        &.grid--catalog\n            grid-template-columns: repeat(3, minmax(300px, 1fr))\n\n        &.grid--contact\n            grid-template-columns: .6fr 1.4fr\n\n    &.grid--contact\n        gap 30px\n        input\n        textarea\n        button\n            max-width none\n            width 100%\n        label\n            display block\n            width 100%\n\n\n.flex\n    display flex\n    flex-wrap wrap\n    margin -15px\n    &.flex--auto\n        flex-wrap nowrap\n\n    &>div\n        display block\n        box-sizing border-box\n        padding 15px\n        width 100%  // Una columna por defecto (mobile first)\n\n    // Media query para tablet (dos columnas)\n    @media (min-width: $tablet)\n        .flex__20\n            width 20%\n\n        .flex__25\n            width 25%\n\n        .flex__30\n            width 30%\n\n        .flex__33\n            width 33.33%\n\n        .flex__35\n            width 35%\n\n        .flex__40\n            width 40%\n\n        .flex__45\n            width 45%\n\n        .flex__50\n            width 50%\n\n        .flex__55\n            width 55%\n\n        .flex__60\n            width 60%\n\n        .flex__65\n            width 65%\n\n        .flex__66\n            width 66.66%\n\n        .flex__70\n            width 70%\n\n        .flex__75\n            width 75%\n\n        .flex__80\n            width 80%\n\n\n","\n\n\n\n.pliego\n    position relative\n    @media (min-width: $mobile)\n        padding-bottom 150%\n    @media (min-width: $tablet)\n        padding-bottom 56.25% // 16:9\n        padding-bottom 54%\n        padding 0\n        height calc(100vh - 180px)\n        min-height 640px\n\n    .pliego__cuts\n        @media (min-width: $mobile)\n            border 2px solid black\n            position absolute\n            top 0\n            left 0\n            width 100%\n            height 100%\n            \n    .pliego__cut\n        @media (min-width: $mobile)\n            position relative\n            width 100%\n            height 50%\n        @media (min-width: $tablet)\n            width 50%\n            height 100%\n            float left\n\n    .pliego__a\n        border 2px solid black\n        margin-bottom -2px\n        background-size cover\n        background-position center center\n        overflow hidden\n\n    @media (min-width: $mobile)\n\n        // Default\n        .pliego__a\n            position relative\n            float left\n            border 0\n            margin 0\n\n            &.pliego__a3\n            &.pliego__a5\n            &.pliego__a7\n            &.pliego__a9\n                //border-right 2px solid black\n                &::after\n                    content \"\"\n                    position absolute\n                    right 0\n                    top 0\n                    width 2px\n                    height 100%\n                    background black\n                    animation pliegoBorderVertical 1s ease backwards\n\n            &.pliego__a1\n            &.pliego__a2\n            &.pliego__a4\n            &.pliego__a6\n            &.pliego__a8\n                //border-bottom 2px solid black\n                &::after\n                    content \"\"\n                    position absolute\n                    left 0\n                    bottom 0\n                    width 100%\n                    height 2px\n                    background black\n                    animation pliegoBorderHorizontal 1s ease backwards\n\n            &.pliego__a1::after\n                animation-delay .2s\n            &.pliego__a2::after\n                animation-delay .3s\n            &.pliego__a3::after\n                animation-delay .4s\n            &.pliego__a4::after\n                animation-delay .5s\n            &.pliego__a5::after\n                animation-delay .6s\n            &.pliego__a6::after\n                animation-delay .7s\n            &.pliego__a7::after\n                animation-delay .8s\n            &.pliego__a8::after\n                animation-delay .9s\n            &.pliego__a9::after\n                animation-delay 1s\n\n\n\n        .pliego__a1\n            width 100%\n            height 100%\n            .pliego__link\n                position absolute\n                bottom 30px\n                left 30px\n\n        .pliego__a2\n            width 100%\n            height 50%\n\n        .pliego__a3\n            height 50%\n            width 50%\n\n        .pliego__a4\n            height 25%\n            width 50%\n\n        .pliego__a5\n            width 25%\n            height 25%\n\n        .pliego__a6\n            width 25%\n            height 12.5%\n\n        .pliego__a7\n            width 12.5%\n            height 12.5%\n\n        .pliego__a8\n            width 12.5%\n            height 6.25%\n\n\n    @media (min-width: $tablet)\n        \n        .pliego__a\n\n            &.pliego__a1\n                //border-bottom 0\n                &::after\n                    right 0\n                    top 0\n                    left auto\n                    bottom auto\n                    width 2px\n                    height 100%\n                    animation-name pliegoBorderVertical\n\n\n","\n// Map ui list\n\n.map__ui\n\n    .map__category\n        //border-top 2px solid black\n        margin 0\n        margin-bottom 10px\n        &:last-child\n            margin 0\n        .map__category_title\n            font-size 1.1em\n            //font-size 1.2em\n            font-size 1em\n            padding 15px 0\n            margin 0\n            cursor pointer\n            border 2px solid black\n            padding 15px 20px\n            transition .2s ease\n            span\n                font-size 1.2em\n                float right\n                margin-left 5px\n        &._opened\n            .map__category_title\n                background rgba($color,.4)\n            .map__accordeon\n                display block\n\n    .map__accordeon\n        overflow hidden\n        animation fadeIn .5s ease\n        display none\n        margin 20px 0\n\n    .map__list\n        list-style-type none\n        padding 0\n        margin 0 0 1px\n        li\n            margin-bottom -1px\n            a\n                display block\n                padding 10px 30px 10px 0\n                border-top 1px solid black\n                border-bottom 1px solid black\n                &:hover\n                    padding-left 15px\n                    padding-right 15px\n                &.active\n                    background rgba($color,.4)\n                    padding-left 15px\n                    padding-right 15px\n\n// Map formats\n\n.map__formats\n    padding 30px\n    animation fadeIn .5s ease\n    ul\n        list-style-type none\n        padding 0\n        strong\n            display block\n            margin-bottom -20px\n        li\n            padding 10px 0\n            border-top 1px solid rgba(0,0,0,.2)\n            animation slideFadeUp .5s ease backwards\n            &:nth-child(1)\n                animation-delay .1s\n            &:nth-child(2)\n                animation-delay .15s\n            &:nth-child(3)\n                animation-delay .2s\n            &:nth-child(4)\n                animation-delay .25s\n            &:nth-child(5)\n                animation-delay .3s\n            li\n                border 0\n                padding 0\n                text-align right\n                animation none\n\n.imprenta-papeles\n    border-top 2px solid black\n    padding-top 15px\n    margin-top 5px\n\n\n\n// Map infowindow styles\n\n.gm-style-iw\n    border-radius 0 !important\n    border 2px solid black\n\n    .gm-style-iw-chr\n        position relative\n        z-index 2\n\n    .gm-style-iw-d\n        margin-top -20px\n\n        .map__infowindow\n            min-width 220px\n            padding 10px\n            padding 0 30px 0 10px\n            position relative\n            z-index 2\n            font-family 'Manrope', Arial, sans-serif\n            h3\n                margin 0 0 10px\n                font-size 1.4em\n            p\n                margin-bottom 10px\n\n.gm-style .gm-style-iw-tc::after\n    background black","\nlabel\n  display inline-block\n  vertical-align middle\n  cursor pointer\n\ninput,select,textarea\n    vertical-align middle\n    line-height 20px\n\ninput,textarea\n    appearance none\n    -webkit-appearance none\n    -moz-appearance none\n    padding 10px 15px\n    border 2px solid black\n    display block\n\n\ninput[type=\"checkbox\"]\n    appearance none\n    -webkit-appearance none\n    -moz-appearance none\n    width 20px\n    height 20px\n    background-color transparent\n    border: 2px solid rgba(0,0,0,.25)\n    border-radius 3px\n    cursor pointer\n\ninput[type=\"checkbox\"]:checked\n    background-color black\n    border-color black\n\ninput[type=\"checkbox\"]:checked::after\n    content \"\"\n    display block\n    width 6px\n    height 10px\n    border 2px solid white\n    border-width 0 2px 2px 0\n    transform rotate(45deg)\n    margin 0 3px\n\n\nselect\n    appearance none\n    -webkit-appearance none\n    -moz-appearance none\n    padding 10px 15px\n    border 2px solid black\n    min-width 120px\n    background url(../img/select.png) right center no-repeat\n    background-size 30px\n\n\n\n// Estilos generales para el contenedor del slider\ninput[type=\"range\"]\n  -webkit-appearance: none // Eliminar estilo predeterminado de Webkit\n  background rgba(0,0,0,.2)\n  height 4px\n  border-radius 20px\n\n\n// Estilos para el thumb del slider\ninput[type=\"range\"]::-webkit-slider-thumb\n  -webkit-appearance: none // Eliminar estilo predeterminado de Webkit\n  appearance: none // Eliminar estilo predeterminado\n  width: 20px // Ancho del thumb\n  height: 20px // Altura del thumb\n  background black\n  border-radius: 50% // Hacer el thumb redondo\n  cursor: pointer // Cambiar cursor al pasar sobre el thumb\n\n// Estilos para el thumb en otros navegadores\ninput[type=\"range\"]::-moz-range-thumb\n  width: 20px // Ancho del thumb\n  height: 20px // Altura del thumb\n  background black\n  border-radius: 50% // Hacer el thumb redondo\n  cursor: pointer // Cambiar cursor al pasar sobre el thumb\n\n// Estilos para el thumb en Edge\ninput[type=\"range\"]::-ms-thumb\n  width: 20px // Ancho del thumb\n  height: 20px // Altura del thumb\n  background black\n  border-radius: 50% // Hacer el thumb redondo\n  cursor: pointer // Cambiar cursor al pasar sobre el thumb\n\n","\n.btn\n    display inline-block\n    user-select none\n    background transparent\n    color black\n    padding 10px 20px\n    border 2px solid black\n    -webkit-appearance none\n    text-transform uppercase\n    font-weight bold\n    font-size .85em\n    @media (min-width: $tablet)\n        font-size .95em\n        letter-spacing 1px\n    cursor pointer\n    border-radius 0\n    transition .2s ease\n    vertical-align middle\n    line-height 20px\n    &:hover\n        background black\n        color white\n        svg\n            path\n                fill white\n    svg\n        display inline-block\n        max-height 16px\n        max-width 16px\n        vertical-align -4px\n        margin 0 5px 0 0\n\n    &.btn--black\n        background black\n        color white\n\n    &.btn--block\n        display block\n        width 100%\n        margin 0\n\n    &.btn--link\n        border 0\n        border-bottom 2px solid transparent\n        padding-left 0\n        padding-right 0\n        &:hover\n            background transparent\n            color black\n            border-color black\n\n\n    &.btn--md\n        padding 12px 25px","\nheader\n    margin-bottom 20px\n    //font-size 20px\n    overflow hidden\n    @media (min-width: $tablet)\n        margin-top 5px\n        margin-bottom 20px\n\n    .header__logo\n        font-weight bold\n        color black\n        text-decoration none\n        display inline-block\n        vertical-align middle\n        margin 0 20px 0 0\n        float left\n        border 0\n        img\n            width 60px\n            height 70px\n            margin 0\n \n    \n    .header__right\n\n        margin-left: 80px\n        @media (min-width: $tablet)\n            margin-left 0\n            padding-top 10px\n            float right\n\n\n    .header__search\n        width 100%\n        position relative\n        display none\n        @media (min-width: $tablet)\n            width 200px\n            display inline-block\n        @media (min-width: $desktop-lg)\n            width 250px\n            \n        input\n            border-radius 0\n            padding-right 40px\n            padding-left 20px\n            width 100%\n            background-color transparent\n        button\n            position absolute\n            border-radius 0\n            top 0\n            right 0\n\n\n    .header__bread\n        opacity .4\n\n    .header__nav\n        display inline-block\n        vertical-align middle\n        margin-right 20px\n        @media (max-width: $tablet)\n            float right\n        ul\n            list-style-type none\n            padding 0\n            margin 0\n            li\n                position relative\n                margin 0 8px\n                display inline-block\n                @media (min-width: $desktop)\n                    margin 0 20px\n                a\n                    font-weight bold\n                    font-size 16px\n                    color black\n                    text-decoration none\n                    display block\n                    padding 2px 0\n                    border-bottom 2px solid transparent\n                    @media (min-width: $desktop)\n                        padding 5px 0\n                    .fa\n                        margin-top -2px\n                    &:hover\n                        border-color black\n                \n                &.current-menu-item\n                    &::before\n                        display block\n                        content \"\"\n                        position absolute\n                        top 50%\n                        left -10%\n                        width 120%\n                        height 40%\n                        background $color\n                        transform rotate(-2deg)\n                        opacity .25\n\n","\n\n#body\n    display none\n\n    &.body--loaded\n        display block !important\n        animation fadeIn .5s ease\n\n","\nfooter\n    margin-top 20px\n    font-size .85em\n    @media (min-width:$tablet)\n        font-size .9em\n    a\n        display block\n        margin 5px 0\n        @media (min-width:$tablet)\n            display inline-block\n            margin 0 6px\n    span\n        display none\n        @media (min-width:$tablet)\n            display inline-block\n\n    .footer__logos\n        .footer__logo\n            margin 0\n            img\n                width 160px\n                height 200px\n                margin 0\n","\n\n// -----------------------------\n// SECTIONS --------------------\n// -----------------------------\n\n\nsection\n    margin-bottom 30px\n    animation fadeIn .5s .2s ease backwards\n    &:last-child\n        margin-bottom 0\n\n    .section__breadcrumb\n        margin-bottom 5px\n        a\n            position relative\n\n    .section__content\n        line-height 1.5\n        font-size 1.2em\n\n    .section__body\n        padding 30px\n    \n    .section__pagination\n        .page-numbers\n            display inline-block\n            padding 5px 10px\n        span\n            background black\n            color white\n            margin 0 5px\n            &:first-child\n                margin-left 0\n\n\n    &.section--border\n        border 2px solid black\n        //padding 30px\n        //min-height 600px\n    \n    &.section--map\n        border 2px solid black\n        margin-bottom 0\n\n        .section__body\n            padding 30px\n            max-height 710px\n            overflow auto\n            @media (min-width: $tablet)\n                height calc(100vh - 190px)\n                max-height none\n\n        #map\n            //min-height 600px\n            height 400px\n            @media (min-width: $tablet)\n                height 100%\n\n        .grid>div:nth-child(2)\n            border-top 2px solid black\n            @media (min-width: $tablet)\n                border-top 0\n                border-left 2px solid black\n\n        .section__title\n            line-height .8\n            margin-bottom 30px\n        \n \n\n    .section__alianzas\n        a\n            display inline-block\n            padding 10px 20px 10px 0\n            border 0\n            img\n                max-height 70px\n                max-width 200px\n                display inline-block\n                vertical-align middle\n\n\n\n    .section__imgbg\n        background center center no-repeat\n        background-size cover\n        height 300px\n        @media (min-width: $tablet)\n            height 600px\n","\n\n// -----------------------------\n// ARTICLES --------------------\n// -----------------------------\n\n\narticle.article--pliego\n    position relative\n    height 100%\n    padding 30px\n    animation slideFadeLeft .8s .2s ease backwards\n    transition .25s ease\n    @media (min-width: $desktop+400)\n        padding 40px\n\n    &:hover\n        background rgba($color,40%)\n        .word\n            &::before\n                background-color white\n\n    &.article--pliego-about\n        animation-delay .5s\n\n    &.article--pliego-imprentas\n        animation-delay .6s\n\n    &.article--pliego-metropolitana\n        animation-delay .7s\n\n    &.article--pliego-valparaiso\n        animation-delay .8s\n\n    &.article--pliego-downloads\n        animation-delay .9s\n\n    &.article--pliego-contact\n        animation-delay 1s\n\n\n\n    .article__excerpt\n        line-height 1.5\n    \n    @media (min-width: $tablet)\n        h1.article__title\n            font-size 3vw\n        h2.article__title\n            font-size 2vw\n        h3.article__title\n            font-size 1.6vw\n            max-width 60%\n\n    .article__link\n        display block\n        position absolute\n        top 0\n        left 0\n        width 100%\n        height 100%\n        border 0\n        svg\n            width 30px\n            height 30px\n            display inline-block\n            vertical-align middle\n            margin-left 10px\n        span\n            position absolute\n            bottom 30px\n            right 30px\n            display inline-block\n            font-size 1.6vw\n            font-weight bold\n            line-height 1.1\n            opacity 0\n            right 40px\n            transition .5s ease\n        &:hover\n            span\n                opacity 1\n                right 30px\n                //animation slideFadeRight .5s ease \n    \n    &.article--pliego-imprentas\n        .article__formats\n            margin-bottom 5px\n            overflow hidden\n            .format-icon\n                animation slideFadeLeft .5s ease backwards\n                &:nth-child(1)\n                    animation-delay .5s\n                &:nth-child(2)\n                    animation-delay .6s\n                &:nth-child(3)\n                    animation-delay .7s\n                &:nth-child(4)\n                    animation-delay .8s\n                &:nth-child(5)\n                    animation-delay .9s\n\n    &.article--pliego-region\n        .article__bread\n        .article__title\n            position relative\n        .article__bg\n            position absolute\n            top 0\n            left 0\n            width 100%\n            height 100%\n            background-size cover\n            background-position center center\n            opacity 1\n            transition .5s ease\n        &:hover\n            background rgba($color,60%)\n            .article__bg\n                opacity .25\n\n    \n    &.article--pliego-small\n        padding 30px\n        .article__link\n            span.texttt\n                display block\n                width 200px\n                bottom 50%\n                right 50%\n                margin-right -100px\n                margin-bottom -16px\n                text-align center\n                opacity 1\n                font-size 20px\n\n\n    &.article--pliego-downloads\n        .article__link\n            span.textttXXXX\n                transform rotate(-90deg)\n    \n\n\n\narticle.article--file\n    a\n        display block\n        padding 15px 0\n        border-top 2px solid black\n        border-bottom 0\n        .article__title\n            display block\n            font-size 1.5em\n            font-weight normal\n        .article__description\n            display block\n            opacity .6\n            margin-bottom 5px\n        .article__download\n            font-weight bold\n            text-transform uppercase\n            display inline-block\n            transition .2s ease\n            padding 5px 10px\n            background black\n            color white\n            @media (min-width: $tablet)\n                margin-top -30px\n                float right\n        &:hover\n            background black\n            padding 15px 20px\n            color white\n\n\n\narticle.article--region-imprentas\n    border 2px solid black\n    margin-bottom -2px\n    .article__title\n        margin 0\n    a\n        display block\n        padding 20px\n        &:hover\n            background black\n            color white\n        span\n            font-weight normal\n            font-size .7em\n            opacity .5\n            display inline-block\n            margin-left 5px\n\narticle.article--result\n    border 2px solid black\n    padding 20px\n\n\n\narticle.article--team\n    .article__image\n        position relative\n        background #EEE\n        border 2px solid black\n        margin-bottom 10px\n    .article__title\n        font-size 1em\n        margin-bottom 5px\n","\n// -----------------------------\n// Swiper ------------------\n// -----------------------------\n\n\n.section__swiper\n    margin 0 -30px\n    @media (min-width: $tablet)\n        margin 0\n\n.swiper.swiper--main\n    position relative\n    user-select none\n    overflow hidden\n\n.swiper-thumbnails\n    display flex\n    gap 5px\n    margin 5px 0 0\n\n    .swiper-thumbnail\n        cursor pointer\n        opacity .6\n        transition .2s ease\n        position relative\n        &.--current\n            opacity 1\n            z-index 2\n            &::after\n                content \"\"\n                display block\n                position absolute\n                top 0\n                left 0\n                width 100%\n                height 100%\n                border 2px solid black\n                box-sizing border-box\n        &:hover\n            opacity 1\n    \n    &.swiper-thumbnails--B\n        display flex\n        //gap 5px\n        gap 0\n        //margin -5px\n        margin 0\n        flex-wrap wrap\n\n        .swiper-thumbnail\n            //padding 5px\n            width 33.33%\n            box-sizing border-box\n                    \n\n.swiper-button-next, .swiper-button-prev\n    color black !important\n    opacity .2\n    transition .2s ease\n    &:hover\n        opacity 1\n\n\n.swiper-pagination-bullet.swiper-pagination-bullet-active\n    background black\n","\n\n.word\n    position relative\n    display inline-block\n    &::before\n        display none\n        content \"\"\n        position absolute\n        top 50%\n        left -5%\n        width 110%\n        height 50%\n        transform rotate(-2deg)\n        opacity .25\n        transition .5s ease\n\n    &.word--optimizar::before,\n    &.word--formatos::before,\n    &.word--eficiente::before\n        display block\n        background $color\n\n","\n.format-header\n    float right\n    text-align right\n    margin -40px 0 10px\n    word-spacing 3px\n    font-size 14px\n    /*span\n        display inline-block\n        vertical-align middle\n        font-size 14px\n        &.format__p\n            width 60px\n            //text-align right\n            margin-right 10px\n        &.format__w\n            width 45px\n            text-align right\n        &.format__h\n            width 45px\n            padding-left 10px\n            text-align left\n    */\n\n.format\n    line-height 1\n    span\n        display inline-block\n        vertical-align middle\n        font-size 14px\n        &.format__p\n            width 60px\n            text-align right\n            margin-right 10px\n        &.format__w\n            font-size 1em\n            width 45px\n            text-align right\n        &.format__h\n            font-size 1em\n            width 45px\n            text-align left\n            padding-left 15px\n        &.format__cm\n            padding-left 2px\n    &:hover\n        background rgba($color,30%)\n\n.format-icon\n    width 16px\n    height 20px\n    display block\n    float left\n    border 1px solid rgba(0,0,0,.8)\n    margin-right 10px\n    margin-bottom 10px\n    position relative\n\n    span\n        display block\n        position relative\n        background rgba($color,50%)\n        border 1px dashed rgba(0,0,0,.6)\n        margin-top -1px\n        margin-left -1px\n\n    &.format-icon-mini\n        span\n            height 20%\n            width 20%\n    &.format-icon-pequeno\n        span\n            height 35%\n            width 35%\n    &.format-icon-mediano\n        span\n            height 50%\n            width 50%\n    &.format-icon-grande\n        span\n            height 65%\n            width 65%\n    &.format-icon-max,\n    &.format-icon-maxi\n        span\n            height 80%\n            width 80%\n\n    &.format-icon-md\n        width 32px\n        height 40px\n\n    &.format-icon-lg\n        width 64px\n        height 80px\n        span\n            border-width 1px\n\n\n// Format unit\n\n.unit\n    border 1px solid black\n    border-radius 8px\n    display block\n    float right\n    margin-left 10px\n    padding 2px\n    .unit-option\n        display inline-block\n        padding 4px 6px\n        cursor pointer\n        border-radius 5px\n        transition .2s ease\n        font-size 14px\n        &.active\n            background rgba($color,50%)\n        \n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
